function mapMovementsToTimelineItems(movements, booking) {
  let timelineItems = [];
  let pickedUp = false;

  // Push the booking placed movement
  timelineItems.push({
    time: booking.placed_at,
    content: "Booking placed",
    required: true
  });

  if (typeof movements != "undefined") {
    movements.forEach(function(movement) {
      const timelineItem = {
        time: movement.time,
        content: "",
        typeId: movement.type_id,
        required: false,
        eroadWhereDeviceId: " "
      };

      if (movement.type_id === 1) {
        timelineItem.content =
          "Picked up from " + booking.pickupLocation.data.name;
        timelineItem.required = true;
        pickedUp = true;
      }

      if (movement.type_id === 2) {
        timelineItem.content =
          "Delivered to " + booking.deliveryLocation.data.name;
        timelineItem.required = true;
      }

      if (movement.type_id === 3) {
        const depotName = movement.name ? movement.name : "Depot";
        timelineItem.content = "Uplifted at " + depotName;
      }

      if (movement.type_id === 4) {
        const depotName = movement.name ? movement.name : "Depot";
        timelineItem.content = "Offloaded at " + depotName;
      }

      if (movement.type_id === 5) {
        timelineItem.content =
          "Allocated to truck [" +
          (movement.truck_plate === null ? "unknown" : movement.truck_plate) +
          "]";
      }

      if (movement.source_id === 6) {
        timelineItem.content =
          "Scanned as " +
          (movement.type_id === 1 ? "picked up" : "offloaded") +
          (movement.name != null ? " at " + movement.name : "");
      }

      if (movement.type_id === 7) {
        let trackerId = movement.eroad_device_id
          ? movement.eroad_device_id.toString().substring(4) + " "
          : !booking.tracker_id
          ? ""
          : booking.tracker_id.toString().substring(4) + " ";
        timelineItem.content = "Tracker " + trackerId + "Linked To Booking";
        timelineItem.required = true;
        timelineItem.eroadWhereDeviceId = trackerId;
      }

      if (movement.type_id === 8) {
        timelineItem.content = "Arrived at transit stop at " + movement.name;
      }

      if (movement.type_id === 9) {
        timelineItem.content = "Left transit stop at " + movement.name;
      }

      if (movement.type_id === 10) {
        let trackerId = movement.eroad_device_id
          ? movement.eroad_device_id.toString().substring(4) + " "
          : "";
        timelineItem.content = "Tracker " + trackerId + "unlinked from booking";
        timelineItem.required = true;
        timelineItem.eroadWhereDeviceId = trackerId;
      }

      if (movement.type_id === 11) {
        timelineItem.content = "POD uploaded";
      }

      if (movement.type_id === 12) {
        timelineItem.content = "Manifested for next leg";
      }

      if (movement.type_id === 13) {
        timelineItem.content = "Delivery estimated";
      }

      // Prevent duplicates that have been inserted in freight_events by tracker
      if (
        !timelineItems.find(
          t =>
            t.time === timelineItem.time && t.content === timelineItem.content
        ) &&
        movement.type_id != 99 &&
        movement.type_id != null &&
        !(movement.type_id == 13 && movement.name === "T.B.A") &&
        //   && !(movement.type_id == 9 && movement.eroad_device_id == null)
        !((movement.type_id == 8 || movement.type_id == 9) && !pickedUp)
      ) {
        timelineItems.push(timelineItem);
      }
    });

    // Extra: try to use eroad where to add the last detected location
    if (
      booking.latestEroadLocation &&
      booking.latestEroadLocation.data.last_location &&
      (booking.status_id === 3 || booking.status_id === 4)
    ) {
      // Tracker last detected will always be pushed to the end so re-sort timeline items to keep a proper sequence
      timelineItems.push({
        time: moment
          .utc(booking.latestEroadLocation.data.last_location_time)
          .local()
          .format("h:mm A ddd Do MMM"),
        content:
          "Tracker last detected at " +
          booking.latestEroadLocation.data.last_location.name
      });
      timelineItems = timelineItems.sort((a, b) => {
        let aDate = moment(a.time, "h:mm A ddd Do MMM");
        let bDate = moment(b.time, "h:mm A ddd Do MMM");
        return aDate > bDate ? 1 : -1;
      });
    }
  }
  return timelineItems;
}

function getPickupTimeFromMovements(movements) {
  const pickupMovement = movements.find(movement => movement.type_id === 1);
  if (pickupMovement !== undefined) {
    return pickupMovement.time;
  }
  return "";
}

function getDeliveryTimeFromMovements(movements) {
  const deliveryMovement = movements.find(movement => movement.type_id === 2);
  if (deliveryMovement !== undefined) {
    return deliveryMovement.time;
  }
  return "";
}

export {
  mapMovementsToTimelineItems,
  getPickupTimeFromMovements,
  getDeliveryTimeFromMovements
};
